import api from './api';

export const companySettingsService = {
  get: () => api.get('/company-settings/'),
  update: (data) => api.put('/company-settings/', data),
};
